module.exports = __webpack_public_path__ + "img/aurora-bg.c26464a4.jpg";